<template>
  <v-chip
    v-if="booking && booking.rent_to_own === true"
    x-small
    color="deep-purple"
    text-color="white"
    class="rent-to-own-chip"
    data-cy="rent-to-own-chip"
    :aria-label="$t('rent_to_own.chip_label')"
  >
    {{ $t("rent_to_own.chip_label") }}
  </v-chip>
</template>

<script>
// FT-173 STEP-19 (REQ-14) — метка договорного бронирования на поверхностях
// со списками/календарями/досками. Рендерится только при
// booking.rent_to_own === true; обычные бронирования (false/undefined) —
// без изменений, компонент ничего не выводит.
export default {
  name: "RentToOwnChip",
  props: {
    booking: {
      type: Object,
      default: null,
    },
  },
};
</script>
